import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbTwoColWrapperBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`two-col-wrapper ${props.attributes.className ? props.attributes.className : ''} ${classes.twoColWrapper} ${classes.twoColWrapperTheme}`}>
        <div className="left">
            {blocks[0]}
        </div>
        <div className="right">
            {blocks[1]}
        </div>
    </div>
};

export const CgbTwoColWrapperBlockFragment = graphql`
  fragment CgbTwoColWrapperBlock on WpBlock {
    ... on WpCgbTwoColWrapperBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbTwoColWrapperBlockPreview = `
    ... on CgbTwoColWrapperBlock {
        name
        attributes {
            className
        }
    }
`;